import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'infra-page_weight-view';
/**
 * Tracks resources loaded on a page for performance analysis.
 */
export function trackInfraPageWeightView(customParameterToken, customParameterToken2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken, customParameterToken2 },
    });
}
